import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppLayout from '@/components/layout/AppLayout';
import AuthLayout from '@/components/layout/AuthLayout';
import LoadingState from '@/components/common/LoadingState';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import ProtectedRoute from '@/routes/ProtectedRoute';
import LoginPage from '@/pages/auth/LoginPage';
import RegisterPage from '@/pages/auth/RegisterPage';
import OTPLoginPage from '@/pages/auth/OTPLoginPage';
import ForgotPasswordPage from '@/pages/auth/ForgotPasswordPage';
import ConfigPage from './pages/config/ConfigPage';


const DashboardPage = lazy(() => import('@/pages/dashboard/DashboardPage'));
const POSPage = lazy(() => import('@/pages/pos/POSPage'));
const ShiftListPage = lazy(() => import('@/pages/shifts/ShiftListPage'));
const TankOverviewPage = lazy(() => import('@/pages/inventory/TankOverviewPage'));
const FinanceOverviewPage = lazy(() => import('@/pages/finance/FinanceOverviewPage'));
const DeviceListPage = lazy(() => import('@/pages/iot/DeviceListPage'));
const ReportsDashboardPage = lazy(() => import('@/pages/reports/ReportsDashboardPage'));
const EmployeeListPage = lazy(() => import('@/pages/hr/EmployeeListPage'));
const CustomersPage = lazy(() => import('@/pages/crm/CustomersPage'));
const StationSettingsPage = lazy(() => import('@/pages/settings/StationSettingsPage'));
const SADashboardPage = lazy(() => import('@/pages/super-admin/SADashboardPage'));
const StationApprovalsPage = lazy(() => import('@/pages/super-admin/StationApprovalsPage'));
const NotFoundPage = lazy(() => import('@/pages/errors/NotFoundPage'));
const ForbiddenPage = lazy(() => import('@/pages/errors/ForbiddenPage'));


 



function LP({ children }: { children: React.ReactNode }) { return <Suspense fallback={<LoadingState message="Loading..."/>}><ErrorBoundary>{children}</ErrorBoundary></Suspense>; }
export default function App() {
  return <Routes>
    <Route element={<AuthLayout/>}><Route path="/login" element={<LoginPage/>}/><Route path="/register" element={<RegisterPage/>}/><Route path="/otp-login" element={<OTPLoginPage/>}/><Route path="/forgot-password" element={<ForgotPasswordPage/>}/></Route>
    <Route element={<ProtectedRoute/>}><Route element={<AppLayout/>}>
      <Route path="/dashboard" element={<LP><DashboardPage/></LP>}/>
      <Route path="/pos" element={<LP><POSPage/></LP>}/>
      <Route path="/shifts" element={<LP><ShiftListPage/></LP>}/>
      <Route path="/inventory" element={<LP><TankOverviewPage/></LP>}/>
      <Route path="/finance" element={<LP><FinanceOverviewPage/></LP>}/>
      <Route path="/iot" element={<LP><DeviceListPage/></LP>}/>
      <Route path="/reports" element={<LP><ReportsDashboardPage/></LP>}/>
      <Route path="/hr" element={<LP><EmployeeListPage/></LP>}/>
      <Route path="/crm" element={<LP><CustomersPage/></LP>}/>
      <Route path="/settings" element={<LP><StationSettingsPage/></LP>}/>
      <Route path="/admin" element={<LP><SADashboardPage/></LP>}/>
      <Route path="/admin/approvals" element={<LP><StationApprovalsPage/></LP>}/>
      <Route path="/forbidden" element={<LP><ForbiddenPage/></LP>}/>
      
    </Route></Route>
    <Route path="/" element={<Navigate to="/dashboard" replace/>}/>
    <Route path="*" element={<LP><NotFoundPage/></LP>}/>
  </Routes>;
}
